import React from 'react'
import ReactDOM from 'react-dom'
import get from 'lodash/get'
import flatMap from 'lodash/flatMap'
import isEmpty from 'lodash/isEmpty'
import every from 'lodash/every'

import { Tooltip } from '../../components/Tooltip'

export const renderChartTooltip = (ctx) => {
  let tooltip = initializeTooltip()
  const tableTooltip = document.getElementById('table-tooltip')

  const tooltipModel = get(ctx, 'tooltip', null)
  const position = ctx.chart.canvas.getBoundingClientRect()

  const dataPoints = get(tooltipModel, 'dataPoints', [])
  const dataset = dataPoints.find((dataset) => dataset.dataset.showCashflowEvents)

  const cashflowEvents = get(dataset, 'raw.cashflowEvents', [])
  const cashflowEventsDrawStatus = get(dataset, 'raw.cashflowEventsDrawStatus', {})

  if (isEmpty(cashflowEvents) || every(cashflowEvents, { status: 'inactive' }) ||
      !tooltipModel || tooltipModel.opacity === 0) {
    tooltip.style.opacity = 0
    tableTooltip.classList.remove('active')
    return
  }

  ReactDOM.render(
    <Tooltip
      hideCloseButton
      cashflowEventsDrawStatus={cashflowEventsDrawStatus}
      cashflowEvents={cashflowEvents}
    />,
    tooltip
  )

  alignTooltip(tooltip, tooltipModel)
  positionTooltip(tooltip, tooltipModel, position)
  setTooltiptOpacity(tooltip, tooltipModel, cashflowEvents)
  tooltip.style.pointerEvents = 'none'
}

const initializeTooltip = () => {
  let tooltip = document.getElementById('chart-tooltip')
  if (!tooltip) {
    tooltip = document.createElement('div')
    tooltip.id = 'chart-tooltip'
    tooltip.classList.add('chart-tooltip')
    tooltip.classList.add('active')
    document.body.appendChild(tooltip)
  }
  return tooltip
}

const alignTooltip = (tooltip, tooltipModel) => {
  tooltip.classList.remove('above', 'below', 'no-transform')
  if (tooltipModel.yAlign) {
    tooltip.classList.add(tooltipModel.yAlign)
  } else {
    tooltip.classList.add('no-transform')
  }
}

const positionTooltip = (tooltip, tooltipModel, position) => {
  tooltip.style.position = 'absolute'
  tooltip.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 5 + 'px'
  tooltip.style.top = position.top + window.pageYOffset + tooltipModel.caretY - tooltip.clientHeight - 10 + 'px'
}

const setTooltiptOpacity = (tooltip, cashflowEvents) => {
  if (isEmpty(cashflowEvents)) {
    tooltip.style.opacity = 0
  } else {
    tooltip.style.opacity = 1
  }
}
